import { render, staticRenderFns } from "./VeHrPerformanceModal__Style#Drawer.vue?vue&type=template&id=72f06c00&scoped=true"
import script from "./VeHrPerformanceModal__Style#Drawer.vue?vue&type=script&lang=js"
export * from "./VeHrPerformanceModal__Style#Drawer.vue?vue&type=script&lang=js"
import style0 from "./VeHrPerformanceModal__Style#Drawer.vue?vue&type=style&index=0&id=72f06c00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f06c00",
  null
  
)

export default component.exports